module.exports = __webpack_public_path__ + "img/111.0a8e941e.jpg";